module.exports = __webpack_public_path__ + "img/dust_scratches.608ab5fe.png";